// ─────────────────────────────────────────────────────────
// components/OfflineBanner.tsx  —  Offline / sync indicators
//
// OfflineBanner: replaces monolith #offline-bar
// SyncBar:       replaces monolith #sync-bar
// Both are rendered in AppLayout and always mounted.
// ─────────────────────────────────────────────────────────
import { useAuthStore } from '@/store/authStore'
import { useUIStore }   from '@/store/uiStore'

// ── Offline warning bar (top of screen) ──────────────────
export function OfflineBanner() {
  const { isOnline } = useAuthStore()

  if (isOnline) return null

  return (
    <div style={{
      position:   'fixed',
      top: 0, left: 0, right: 0,
      zIndex:     9998,
      background: 'var(--color-warn)',
      color:      '#fff',
      padding:    '8px 16px',
      fontSize:   12.5,
      fontWeight: 600,
      display:    'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
    }}>
      <span>📡</span>
      You are offline — changes saved locally and will sync when connection is restored
    </div>
  )
}

// ── Sync status bar (bottom-right corner) ────────────────
export function SyncBar() {
  const { isSyncing, syncMsg } = useUIStore()

  if (!isSyncing) return null

  return (
    <div style={{
      position:   'fixed',
      bottom: 16, right: 16,
      zIndex:     9997,
      background: 'var(--color-sf2)',
      color:      'var(--color-tx)',
      border:     '1px solid var(--color-bd)',
      padding:    '8px 14px',
      borderRadius: 8,
      fontSize:   12,
      fontWeight: 600,
      display:    'flex',
      alignItems: 'center',
      gap: 7,
      boxShadow:  'var(--shadow-lg)',
    }}>
      <span style={{
        display:   'inline-block',
        animation: syncMsg?.includes('✓') ? 'none' : 'spin .7s linear infinite',
      }}>
        {syncMsg?.includes('✓') ? '✓' : '⟳'}
      </span>
      {syncMsg}
    </div>
  )
}
